import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import { ITargetsData, ITargetsDataError, RuleType } from "components/product-collection/footer/types";

export class NotEmptyRule extends Validator<ITargetsData[], ITargetsDataError> {
    validate(rows: ITargetsData[], errors: ITargetsDataError): ITargetsDataError {
        const notEmptyErrorType = RuleType.NotEmptyRule;
        const isFileEmpty = rows.length === 0;

        const validationErrors = !isFileEmpty
            ? errors
            : {
                  ...errors,
                  [notEmptyErrorType]: formatMessage(
                      "No data found. If your file has multiple tabs, please make sure your data is on the first tab."
                  ),
              };

        return super.validate(rows, validationErrors);
    }
}
